export default "__VITE_ASSET__tvZAnq5Q__"